export default __webpack_public_path__ + "static/media/valid-check-icon.bd014867.svg";